import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ExpandingButton } from '@atlassian/help-center-common-component/expanding-button';

const ICON_HEIGHT = (grid.unitless / 2) * 5;

// eslint-disable-next-line rulesdir/no-styled-export
export const CustomIconSizeExpandingButton = styled(ExpandingButton)`
    /* This is trying ensure we dip into the actual atlaskit icon element atm. No nice hook right now. */
    span > span,
    svg {
        height: ${ICON_HEIGHT}px;
        width: ${ICON_HEIGHT}px;
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const IconContainer = styled.span`
    padding-right: ${token('space.100', '8px')};
    border-radius: 50%;
    display: flex;
    overflow: visible;
    position: relative;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const StyledSearchIconContainer = styled.div`
    display: flex;
    height: ${token('space.400', '32px')};
    width: ${token('space.400', '32px')};
    align-items: stretch;
    background-color: ${token('elevation.surface.overlay', colors.N30)};
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    transform: translateZ(0);
    transition: transform 200ms, opacity 200ms;
    box-shadow: ${token('space.0', '0px')} ${token('space.0', '0px')} ${token('space.0', '0px')}
        ${token('space.025', '2px')} ${token('color.border.inverse', colors.N0)};
    border: none;
    margin: ${token('space.150', '12px')};
    padding: 0;
    cursor: pointer;
`;
